/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectInstance} from "../../models/object-instance";

export class MainDisplayParameter {
  name: string;
  value: string;

 public static getDisplayParameters(object: ObjectInstance): MainDisplayParameter[] {
    let resultList = null;
    const results = object.data.filter(d => d.property.mainDisplay == true);
    if (results) {
      resultList = [];
      for (const result of results) {
        const mainDisplayParameter = new MainDisplayParameter();
        mainDisplayParameter.name = result.property.name;
        mainDisplayParameter.value = result.value;
        resultList.push(mainDisplayParameter);
      }
    }

    return resultList;
  }
}
